module.exports = __webpack_public_path__ + "img/logo_toyo.2d32a1e5.png";